import AdminOnboardingBottomArea from "./AdminOnboardingBottomArea";

export default AdminOnboardingBottomArea;
